import { apiClient } from './apiClient';

export type Permission = {
  id: number;
  name: string;
};

export function getPermissions(params?: {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortType?: string;
}): Promise<{ results: Permission[]; totalCount: number }> {
  return apiClient.get(`/permissions`, { ...params });
}

export function createPermission(payload: {
  name: string;
}): Promise<Permission> {
  return apiClient.post(`/permissions`, payload);
}

export function updatePermission(
  id: number,
  payload: { name: string }
): Promise<Permission> {
  return apiClient.put(`/permissions/${id}`, payload);
}

export function deletePermission(id: number): Promise<void> {
  return apiClient.del(`/permissions/${id}`);
}

export function validateCreatePermission(payload: {
  name: string;
}): Promise<{ valid: boolean; message: string }> {
  return apiClient.post(`/permissions/validate-create`, payload);
}

export function validateUpdatePermission(
  id: number,
  payload: { name: string }
): Promise<{ valid: boolean; message: string }> {
  return apiClient.post(`/permissions/${id}/validate-update`, payload);
}
